<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "SkupTema2Base"
};
</script>

<style scoped>

</style>
